export const Main = ({ children }) => {
    return (<div className='main-content'>
        {children}
    </div>)
}